// Assuming httpTools has its types defined or imported

import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

interface PostData {
  type: string
  value: string
  namespace: string
}

interface LoginData {
  username: string
  password: string
}

type HydraGetLoginTokenResponse = {
  customer: {
    href: string
  }
  expired: boolean
  href: string
  token: string
  whoami: {
    href: string
  }
  error?: {
    code: number
    message: string
  }
}

const getPostData = ({ username, password }: LoginData): PostData => ({
  type: 'base64',
  value: btoa(`${username}:${password}`),
  namespace: `${process.env.NEXT_PUBLIC_HYDRA_BASE_URL}/customers`,
})

export const HydraGetLoginToken = ({ username, password }: LoginData) => {
  const postData: PostData = getPostData({ username, password })
  const request: SendRequestType = {
    method: 'POST',
    data: postData,
    url: '/loginTokens',
    withAuth: false,
  }

  return httpTools.sendRequest<HydraGetLoginTokenResponse>(request)
}
